import { churchesApi } from '../api/churchesApi'

export const getPublicChurches = async () => {
  try {
    const {
      data: { churches },
    } = await churchesApi.getPublicChurches()
    return churches
  } catch (error) {
    console.error(`Error fetching public churches: `, error)
    throw error
  }
}
